// Keys for `useOrganizationList`
const USER_MEMBERSHIPS_KEY = 'userMemberships';
const USER_INVITATIONS_KEY = 'userInvitations';
const USER_SUGGESTIONS_KEY = 'userSuggestions';

// Keys for `useOrganization`
const DOMAINS_KEY = 'domains';
const MEMBERSHIP_REQUESTS_KEY = 'membershipRequests';
const MEMBERSHIPS_KEY = 'memberships';
const INVITATIONS_KEY = 'invitations';

// Keys for `useAPIKeys`
const API_KEYS_KEY = 'apiKeys';

// Keys for `useOrganizationCreationDefaults`
const ORGANIZATION_CREATION_DEFAULTS_KEY = 'organizationCreationDefaults';

// Keys for `useOAuthConsent`
const OAUTH_CONSENT_INFO_KEY = 'oauthConsentInfo';

// Keys for `usePlans`
const PLANS_KEY = 'billing-plans';

// Keys for `useSubscription`
const SUBSCRIPTION_KEY = 'billing-subscription';

// Keys for `usePaymentMethods`
const PAYMENT_METHODS_KEY = 'billing-payment-methods';

// Keys for `usePaymentAttempts`
const PAYMENT_ATTEMPTS_KEY = 'billing-payment-attempts';

// Keys for `useStatements`
const STATEMENTS_KEY = 'billing-statements';

// Keys for `useCreditBalance`
const CREDIT_BALANCE_KEY = 'billing-credit-balance';

export const STABLE_KEYS = {
  // Keys for `useOrganizationList`
  USER_MEMBERSHIPS_KEY,
  USER_INVITATIONS_KEY,
  USER_SUGGESTIONS_KEY,

  // Keys for `useOrganization`
  DOMAINS_KEY,
  MEMBERSHIP_REQUESTS_KEY,
  MEMBERSHIPS_KEY,
  INVITATIONS_KEY,

  // Keys for billing
  PLANS_KEY,
  SUBSCRIPTION_KEY,
  PAYMENT_METHODS_KEY,
  PAYMENT_ATTEMPTS_KEY,
  STATEMENTS_KEY,

  // Keys for `useAPIKeys`
  API_KEYS_KEY,

  // Keys for `useOrganizationCreationDefaults`
  ORGANIZATION_CREATION_DEFAULTS_KEY,

  // Keys for `useOAuthConsent`
  OAUTH_CONSENT_INFO_KEY,

  // Keys for `useCreditBalance`
  CREDIT_BALANCE_KEY,
} as const;

export type ResourceCacheStableKey = (typeof STABLE_KEYS)[keyof typeof STABLE_KEYS];

/**
 * Internal stable keys for queries only used by our UI components.
 * These keys are not used by the hooks themselves.
 */

const PAYMENT_ATTEMPT_KEY = 'billing-payment-attempt';
const BILLING_PLANS_KEY = 'billing-plan';
const BILLING_STATEMENTS_KEY = 'billing-statement';
const USER_ENTERPRISE_CONNECTIONS_KEY = 'userEnterpriseConnections';
const ENTERPRISE_CONNECTION_TEST_RUNS_KEY = 'enterpriseConnectionTestRuns';
const ORGANIZATION_ENTERPRISE_CONNECTIONS_KEY = 'organizationEnterpriseConnections';
const ORGANIZATION_ENTERPRISE_CONNECTION_TEST_RUNS_KEY = 'organizationEnterpriseConnectionTestRuns';
const ORGANIZATION_DOMAINS_KEY = 'organizationDomains';
const ORGANIZATION_DIRECTORY_SYNC_KEY = 'organizationDirectorySync';
const ORGANIZATION_DIRECTORY_SYNC_USERS_KEY = 'organizationDirectorySyncUsers';
const ORGANIZATION_DIRECTORY_SYNC_STATUS_KEY = 'organizationDirectorySyncStatus';
const ORGANIZATION_DIRECTORY_SYNC_GROUP_ROLE_MAPPINGS_KEY = 'organizationDirectorySyncGroupRoleMappings';
const ORGANIZATION_SSO_BYPASS_ALLOWLIST_KEY = 'organizationSSOBypassAllowlist';

const CREDIT_HISTORY_KEY = 'billing-credit-history';

export const INTERNAL_STABLE_KEYS = {
  PAYMENT_ATTEMPT_KEY,
  BILLING_PLANS_KEY,
  BILLING_STATEMENTS_KEY,
  CREDIT_HISTORY_KEY,
  USER_ENTERPRISE_CONNECTIONS_KEY,
  ENTERPRISE_CONNECTION_TEST_RUNS_KEY,
  ORGANIZATION_ENTERPRISE_CONNECTIONS_KEY,
  ORGANIZATION_ENTERPRISE_CONNECTION_TEST_RUNS_KEY,
  ORGANIZATION_DOMAINS_KEY,
  ORGANIZATION_DIRECTORY_SYNC_KEY,
  ORGANIZATION_DIRECTORY_SYNC_USERS_KEY,
  ORGANIZATION_DIRECTORY_SYNC_STATUS_KEY,
  ORGANIZATION_DIRECTORY_SYNC_GROUP_ROLE_MAPPINGS_KEY,
  ORGANIZATION_SSO_BYPASS_ALLOWLIST_KEY,
} as const;

export type __internal_ResourceCacheStableKey = (typeof INTERNAL_STABLE_KEYS)[keyof typeof INTERNAL_STABLE_KEYS];
